import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { GameProvider } from '@core/models/game-provider.model';

@Injectable()
export class GameProviderEntityService extends EntityCollectionServiceBase<GameProvider> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('GameProviders', serviceElementsFactory);
  }
}